module.exports = {"230422100":"绥滨镇","230422101":"绥东镇","230422102":"忠仁镇","230422200":"连生乡","230422201":"北岗乡","230422202":"富强乡","230422203":"北山乡","230422204":"福兴乡","230422205":"新富乡","230422400":"绥滨西林场","230422401":"国营中兴边防林场","230422480":"忠仁镇良种场","230422481":"绥东镇种畜场","230422500":"二九０农场","230422501":"绥滨农场","230422503":"普阳农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230422.json
// module id = 722
// module chunks = 0